import * as Sentry from '@sentry/browser'

class ErrorLoggingService {
  logError (error) {
    const store = require('@/vuex/store').default // <— lazy import as tests were being affected by import
    const email = store?.state?.userProfileStore?.userProfile?.email
    Sentry.configureScope((scope) => {
      scope.setUser({ email: email })
    })
    Sentry.captureException(error)
  }
}
export default new ErrorLoggingService()
